import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import RLPortfolio from '../components/rl/RLPortfolio';

function PortfolioPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          📊 RL Portfolio Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Monitor your reinforcement learning agent's trading performance and portfolio
        </Typography>
      </Box>

      <RLPortfolio />
    </Container>
  );
}

export default PortfolioPage;